import React, { useEffect, useState } from "react";
import { categoryApi } from "../apis/homeApi";
import axios from "axios";
import { Link } from "react-router-dom";

const CategoryCard = () => {
  const [categorys, setCategorys] = useState([]);
  useEffect(() => {
    try {
      axios.get(categoryApi).then((response) => {
        if (response.status === 200) {
          setCategorys(response?.data?.data);
        }
      });
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  }, []);

  return (
    <>
      {categorys.map((category, index) => (
        <div className="col-lg-2 col-md-3 col-sm-4 col-6 d-flex" key={index}>
          <Link to={`/category/course/${category.slug}`} className="catbox">
            <img
              src={category?.icon}
              className="img-fluid "
              alt={category?.category}
            />
            <p>{category?.category}</p>
          </Link>
        </div>
      ))}
    </>
  );
};

export default CategoryCard;
